import React, { Component } from 'react';

class StickyBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
    };

    this.$stickyBlockRef = React.createRef();
  }

  handleScroll = () => {
    const sticky = this.$stickyBlockRef.current;
    const stickyEnter = parseInt(sticky.getAttribute('data-sticky-start'), 10);

    if (window.scrollY >= stickyEnter) {
      sticky.classList.add('sticky');
      sticky.classList.remove('not-stuck');
    } else {
      sticky.classList.remove('sticky');
      sticky.classList.add('not-stuck');
    }
  };

  componentDidMount() {
    const sticky = this.$stickyBlockRef.current;
    sticky.setAttribute('data-sticky-start', sticky.getBoundingClientRect().top + window.scrollY);

    this.handleScroll();
    
    window.addEventListener('scroll', this.handleScroll, false);
    window.addEventListener('resize', this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
    window.removeEventListener('resize', this.handleScroll, false);
  }

  componentDidCatch() {
    this.setState(error => ({ error: true }));
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    return error ? (
      children
    ) : (
      <div className="sticky-block" ref={this.$stickyBlockRef}>
        {children}
      </div>
    );
  }
}

export default StickyBlock;
